import { combineReducers } from "redux";
import filterDataReducer from "./reducer/filterDataReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
var filterDataPersist = {
    key: "filters",
    storage: storage,
};
export default combineReducers({
    filterDataReducer: persistReducer(filterDataPersist, filterDataReducer),
});
